// Check if the script tag is already in the DOM
if (!document.getElementById('g2-review-js')) {
    // Create a new script element
    const script = document.createElement('script');
    script.id = 'g2-review-js';
    script.src = 'https://my.g2.com/assets/review_widget.js';
    script.async = true; // Optional: Makes the script load asynchronously

    // Append the script to the head of the document
    document.head.appendChild(script);
}